import { useState, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { FaHome, FaTrophy, FaUser, FaDice, FaStopwatch } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "./MobileFooter.css";
import { useSelector } from "react-redux";

export default function MobileFooter() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  // console.log(user, "user");
  const menuItems = [
    { key: "home", label: "Home", icon: <FaHome size={26} />, link: "/" },
    {
      key: "inplay",
      label: "In-Play",
      icon: <FaStopwatch size={26} />,
      link: "/inplay",
    },
    {
      key: "sports",
      label: "Sports",
      icon: <FaTrophy size={26} />,
      link: "/sports",
    },
    {
      key: "casino",
      label: "Casino",
      icon: <FaDice size={26} />,
      link: "/casino",
    },
    {
      key: "user-dashboard",
      label: "Account",
      icon: <FaUser size={26} />,
      link: "/user-dashboard",
    },
  ];

  const [active, setActive] = useState("");
  useEffect(() => {
    const current = menuItems.find((item) => item.link === location.pathname);
    if (current) setActive(current.key);
  }, [location.pathname]);

  return (
    <Navbar fixed="bottom" className="mobile-footer">
      <Nav className="w-100 d-flex justify-content-around text-center">
        {menuItems.map((item, index) => {
          const isActive =
            item.link === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.link);

          return (
            <Nav.Link
              key={item.key}
              role="button"
              data-label={item.label}
              onClick={() => navigate(item.link)}
              // className={`footer-item ${index === 2 ? "center-icon" : ""} ${isActive ? "active" : ""}`}
              className={`footer-item ${isActive ? "active center-icon" : ""}`}
            >
              <div className="icon-container">
                <div className="icon">{item.icon}</div>
              </div>
            </Nav.Link>
          );
        })}
      </Nav>
    </Navbar>
  );
}
